module.exports = __webpack_public_path__ + "static/media/grafico_arrecadacao_02.94fa797.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/grafico_arrecadacao_02.mp4
// module id = d8ap
// module chunks = 0